import React from "react";

const LeftBanner = () => {
	return (
		<div className="col-xs-3 left-column-hide">
			<div className="left-column-banner" />
		</div>
	);
};

export default LeftBanner;
